import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'new':
        return {
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          label: 'New'
        };
      case 'contacted':
        return {
          bg: 'bg-yellow-100',
          text: 'text-yellow-800',
          label: 'Contacted'
        };
      case 'qualified':
        return {
          bg: 'bg-purple-100',
          text: 'text-purple-800',
          label: 'Qualified'
        };
      case 'booked':
        return {
          bg: 'bg-green-100',
          text: 'text-green-800',
          label: 'Booked'
        };
      case 'completed':
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          label: 'Completed'
        };
      case 'cancelled':
        return {
          bg: 'bg-red-100',
          text: 'text-red-800',
          label: 'Cancelled'
        };
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          label: status
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-body font-medium ${config?.bg} ${config?.text}`}>
      {config?.label}
    </span>
  );
};

export default StatusBadge;